// Packages and components
import React from 'react';
import { Box, Meter } from 'grommet';

// Helpers and utlities
import { progressSize, thicknessSize } from '@theme/globals/sizing';

// Types
import type { SHDProgressProps } from './SHDProgress.d';
import type { BasicTShirtSizing } from '@theme/theme.d';

const SHDProgress: React.FC<SHDProgressProps> = ({
  className = 'progress',
  color = 'brand',
  max = 100,
  round = true,
  size = 'medium',
  type = 'bar',
  value = null,
}) => {
  // Renderers
  const renderValueProp = () => {
    if (typeof value === 'number') {
      return {
        value: value,
      };
    }

    if (Array.isArray(value) && value.length > 0) {
      return {
        values: value,
      };
    }

    return {
      value: 0,
    };
  };

  const renderRoundness = () => {
    if (type === 'pie') {
      return false;
    }
    return round;
  };

  return (
    <Box className={className}>
      <Meter
        a11yTitle="A meter for determining progress."
        aria-label="meter"
        background="gray-200"
        color={color}
        max={max}
        round={renderRoundness()}
        size={progressSize[size as BasicTShirtSizing]}
        thickness={thicknessSize[size as BasicTShirtSizing]}
        type={type}
        {...renderValueProp()}
      />
    </Box>
  );
};

export default SHDProgress;
